module.exports = __webpack_public_path__ + "img/stock3.2a1fef91.png";